import { ServiceData, SlotService } from '../state/types';
import { mapToArray } from '..';
import { OfferedAsType } from '../mappers/serviceMapper/utils/payment.mapper';

/**
 * A service that can ONLY be paid for with a pricing plan. Pricing plans can't be
 * combined with more than one participant, so the collect-participant-form flow is
 * disabled for these services (mirrors the book-for-someone-else availability rule).
 */
const hasPricingPlanOnlyService = (
  serviceData?: ServiceData | null,
): boolean => {
  if (!serviceData?.slotServices) {
    return false;
  }

  return mapToArray<SlotService>(serviceData.slotServices).some(
    ({ service }) =>
      service.payment?.offeredAs?.length === 1 &&
      service.payment.offeredAs[0] === OfferedAsType.PRICING_PLAN,
  );
};

/**
 * The collect-participant-form flow (a separate booking form per participant) is
 * active when the FT is on, the service policy enables it, the service allows more
 * than one participant, and it isn't a pricing-plan-only service.
 */
export const getIsCollectParticipantFormActive = (
  serviceData: ServiceData | null | undefined,
  isFeatureEnabled: boolean,
): boolean =>
  isFeatureEnabled &&
  !!serviceData?.collectParticipantForm &&
  (serviceData?.maxNumberOfParticipants ?? 0) > 1 &&
  !hasPricingPlanOnlyService(serviceData);
